<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 资料下载卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <span style="font-weight: bold">资料下载</span>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="upload_time" label="上传时间" width="200" sortable>
          </el-table-column>
          <el-table-column prop="title" label="资料名称" width="200">
          </el-table-column>
          <el-table-column prop="type" label="分类" width="200"> </el-table-column>
          <el-table-column prop="desc" label="资料描述"> </el-table-column>
          <el-table-column prop="download" label="下载" width="160">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                round
                @click="go_download(scope.row.filename, scope.row.title)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap" v-if="tableData.length !== 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "reserveList",
  data() {
    return {
      // 总条目数 total
      aSum: 100,
      // 当前页数
      currentPage: 1,
      // 总页数
      pageCount: 10,
      // 每页显示条目数
      pagesize: 10,
      tableData: [],
      fileUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/file/",
    };
  },
  mounted() {
    this.downloadList();
  },
  methods: {
    /** 获取资料下载列表 */
    downloadList() {
      let url = this.baseUrl + "/user/files/";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    /** 下载文件 */
    go_download(filename, filetitle) {
      const x = new window.XMLHttpRequest();
      x.open("GET", this.fileUrl + filename, true);
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = filetitle;
        a.click();
      };
      x.send();
    },

    /** 分页切换 */
    handleCurrentChange(val) {
      let url = this.baseUrl + "/user/files/?page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage/downloadList.vue